import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotHomeSmallAppliancesComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotHomeSmallAppliances',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M14.284 1.995h-7.11c-1.16 0-2.08.99-1.99 2.15l.04.64h11.02l.04-.64c.08-1.16-.84-2.15-2-2.15ZM5.004 22.005h11.46c.69 0 1.17-.68.94-1.33l-1.84-5.26h-9.67l-1.84 5.26c-.22.65.26 1.33.95 1.33Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M10.734 20.675a1.96 1.96 0 1 0 0-3.92 1.96 1.96 0 0 0 0 3.92ZM16.184 5.685l.06-.9H5.224l.67 10.62h9.68l.08-1.3h1.44c1.79 0 2.911-1.46 2.911-3.25v-1.92c0-1.79-1.121-3.25-2.911-3.25h-.91Zm-.16 2.5h1.07c.41 0 .75.34.75.75v1.92c0 .41-.34.75-.75.75h-1.29l.22-3.42Z"
  }));
};
SpotHomeSmallAppliancesComponent.displayName = 'SpotHomeSmallAppliances';
export var SpotHomeSmallAppliances = withProvisionalOverrideFromContext(SpotHomeSmallAppliancesComponent);
//# sourceMappingURL=index.js.map